import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { cn } from '@/lib/cn';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { api } from '@/lib/api';
import { usePeriodStore } from '@/lib/periodStore';
import { useMonthStore } from '@/lib/monthStore';
import type { Month } from '@/types';

export default function AppLayout() {
  const [months, setMonths] = useState<Month[]>([]);
  const [loading, setLoading] = useState(true);
  const setAllMonthIds = usePeriodStore((s) => s.setAllMonthIds);
  const monthIds = usePeriodStore((s) => s.monthIds);
  const { selectedMonthId, setSelectedMonthId } = useMonthStore();

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const data = await api.get<Month[]>('/months');
        if (!mounted) return;
        setMonths(data);
        setAllMonthIds(data.map((m) => m.id));
        if (!selectedMonthId && data.length > 0) {
          setSelectedMonthId(data[0].id);
        }
      } catch (err) {
        console.error('Error cargando meses:', err);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [selectedMonthId, setSelectedMonthId, setAllMonthIds]);

  return (
    <div className="min-h-screen">
      <Sidebar />
      <TopBar
        months={months}
        selectedMonthId={selectedMonthId}
        onSelectMonth={setSelectedMonthId}
      />
      <main className="ml-sidebar-width pt-20 pb-12 px-6 min-h-screen">
        {loading ? (
          <div className="flex items-center justify-center h-64">
            <div
              className={cn(
                'px-12 py-10 flex flex-col items-center gap-3',
                'bg-surface-container border-2 border-outline',
                'shadow-[4px_4px_0_0_#000000]',
              )}
            >
              <span className="material-symbols-outlined text-5xl text-primary animate-spin">
                progress_activity
              </span>
              <p className="font-mono uppercase tracking-widest text-xs text-secondary">
                Cargando::datos
              </p>
            </div>
          </div>
        ) : (
          <div key={monthIds.join(',')}>
            <Outlet />
          </div>
        )}
      </main>
    </div>
  );
}
